import React from 'react';

const LoadingView = ({text = 'Loading ...'}) => (
  <div
    className={[
      'fixed',
      'top-0 bottom-0 left-0 right-0',
      'z-50',
      'flex flex-col',
      'items-center justify-center',
      'w-full h-screen',
      'overflow-hidden',
      'bg-gray-700 opacity-75',
    ].join(' ')}
  >
    <div
      className={[
        'w-12 h-12',
        'mb-4',
        'ease-linear',
        'border-4',
        'rounded-full',
        'spinner',
        'animate-spin',
      ].join(' ')}
    />
    <p className="text-xl font-semibold text-center text-white max-w-sm">{text}</p>
  </div>
);

export default LoadingView;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/LoadingView/index.jsx